import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderEasterDevo from "../../../../src/content/fg-easter-devotional/donationHeader";
import "../../../../src/content/fg-easter-devotional/easter-devo.scss";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderEasterDevo,
  React
};